import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import SectionLabel from "./SectionLabel";

const OUTCOMES = [
  { n: "01", word: "Consistent", body: "Your brand looks consistent everywhere." },
  { n: "02", word: "Sharper", body: "Your communication becomes sharper." },
  { n: "03", word: "Faster", body: "Your execution becomes faster." },
  { n: "04", word: "Measurable", body: "Your outcomes become measurable." },
];

const Outcomes = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-120px" });

  return (
    <section
      ref={ref}
      data-testid="outcomes-section"
      className="relative py-24 md:py-32 border-t-2 border-black"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-12">
          <div className="lg:col-span-7">
            <SectionLabel className="mb-6" testid="label-outcomes">
              [ 02 ] - WHAT THIS CHANGES
            </SectionLabel>
            <h2
              className="font-archivo font-black h-tighter text-4xl md:text-5xl lg:text-6xl text-black"
              style={{ fontFamily: "Archivo, sans-serif" }}
            >
              Not a better-looking brand.
              <br />
              <span className="text-[#AE519F]">A structured presence that performs.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p
              className="text-black/70 text-base md:text-lg max-w-md"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              When the same team owns the system, output doesn't just look
              different - the entire engine behaves differently.
            </p>
          </div>
        </div>

        {/* Outcome line - connecting SVG path */}
        <div className="relative">
          <svg
            viewBox="0 0 1200 60"
            preserveAspectRatio="none"
            className="absolute inset-x-0 top-12 w-full h-12 hidden md:block pointer-events-none"
            aria-hidden
          >
            <motion.path
              d="M 30 30 L 1170 30"
              stroke="#000000"
              strokeWidth="1.2"
              fill="none"
              initial={{ pathLength: 0 }}
              animate={inView ? { pathLength: 1 } : { pathLength: 0 }}
              transition={{ duration: 1.6, ease: [0.22, 0.61, 0.36, 1] }}
            />
          </svg>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-black/30 relative">
            {OUTCOMES.map((o, i) => (
              <motion.div
                key={o.n}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: i * 0.12 }}
                viewport={{ once: true }}
                className="bg-[#CCD6DC] p-8 relative"
              >
                {/* node */}
                <div className="hidden md:block absolute -top-1.5 left-8 w-3 h-3 border border-black bg-[#CCD6DC]" />
                <div className="mono-label mb-5">{`OUT / ${o.n}`}</div>
                <div
                  className="text-[#AE519F] text-3xl md:text-4xl mb-3"
                  style={{
                    fontFamily: "Archivo, sans-serif",
                    fontWeight: 800,
                    letterSpacing: "-0.025em",
                  }}
                >
                  {o.word}
                </div>
                <div
                  className="text-black/75 text-base"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {o.body}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Outcomes;
